<template lang="pug">
  v-select.per-page-select(
    label="Rows per page"
    :items="options"
    :value="currentPerPageCount"
    @change="setCountPerPage"
  )
</template>

<script>
  import { PerPageStorage } from '@/models/perPageStorage.js'
  import { DEFAULT_PAGINATION } from '@/util/const'

  export default {
    data: () => ({
      options: [10, 20, 30, 40, 50, 100, 150, 200],
      storage: null,
    }),
    mounted() {
      this.init();
    },
    computed: {
      currentPerPageCount() {
        if (this.storage) {
          return this.storage.getPerPageCount()
        }
        return DEFAULT_PAGINATION.SIZE;
      }
    },
    methods: {
      init() {
        this.storage = new PerPageStorage();
      },
      setCountPerPage(value) {
        this.storage.savePerPageCount(value);
        this.$emit('change', value);
      }
    }
  }
</script>

<style lang="scss" scoped>

  .per-page-select{
    max-width: 100px;
    width: 100%;
    position: absolute;
    bottom: -5px;
  }

</style>